<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">团购商品管理</li>
            </ol>
        </div>
        <div class="content-query content-border">
            <el-form :inline="true" :model="query" class="demo-form-inline">
                <el-form-item>
                    <el-button type="primary" size="small"
                               @click="teamGoodsDetail('')">
                        添加
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <hr/>
        <div class="title">
            <span>特惠商品列表</span>
        </div>
        <div class="content-data">
            <el-table highlight-current-row
                      :data="goodes" border ref="multipleTable">

                <el-table-column type="index" width="50" label="序号"/>
                <el-table-column align="center" label="名称" prop="goodsName"/>
                <el-table-column align="center" label="图片" prop="iconPath">
                    <template slot-scope="scope">
                        <el-image style="height: 100px; width: 100px;" :src="dynamicPath+scope.row.iconPath">
                            <div slot="error" class="image-slot">
                                <el-image title="加载失败"
                                          src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png"/>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="原价" prop="goodsPrice"/>
                <el-table-column align="center" label="团购价" prop="memberPrice"/>
                <el-table-column align="center" label="发起人价" prop="leaderPrice"/>
                <el-table-column align="center" label="成员数量" prop="memberAmount"/>
                <el-table-column align="center" label="团购次数" prop="teamAmount"/>
                <el-table-column align="center" label="完成次数" prop="doneAmount"/>
                <el-table-column align="center" label="拼团次数" prop="doingAmount"/>
                <el-table-column align="center" label="销售状态" prop="saleStatus"/>

                <el-table-column align="center" fixed="right" label="操作" width="500px">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" round
                                   @click="teamGoodsDetail(scope.row.id)">
                            详情
                        </el-button>
                        <el-button type="danger" size="mini" round
                                   @click="deleteGoods(scope.row.id)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <vue-pager v-bind:datafile="fillData" url="teamGoods/pageByManager" v-bind:query="query" ref="pager"
                   v-bind:init="true"/>
        <div class="content-modal">
            <team-goods-add ref="teamGoodsAdd" :success="submitQuery"  :goodsId="goodsId" />
        </div>
    </div>
</template>
<script>
    import teamGoodsAdd from './team-goods-add';

    export default {
        data() {
            return {
                goodes: [],
                query: {},
                dynamicPath: config.dynamicResourcePath,
                timeId: '',
                tableTitle: '',
                goodsId: '',
            }
        },
        created() {
        },
        components: {
            teamGoodsAdd,
        },
        methods: {
            teamGoodsDetail(_id) {
                this.goodsId = _id;
                this.$refs.teamGoodsAdd.openDialog();
            },
            fillData(response) {
                this.goodes = response.items || [];
            },
            submitQuery(_num) {
                const _this = this;
                _this.goodes = [];
                _this.$refs.pager.gotoPage(_num);
            },
            deleteGoods(_goodsId) {
                const _this = this;
                _this.$common.ajaxRequest({
                    url: '/teamGoods/deleteTeamGoods',
                    data: {
                        teamGoodsId: _goodsId,
                    },
                    success(response) {
                        _this.submitQuery(1)
                    }
                })
            },
        },
    }
</script>
<style scoped>
</style>